import React from 'react'
import { NavLink } from 'react-router-dom';
export default function TopMenu(props) {
    return (
        <div className='topmenu-body'>
            <ul>
                {props.items.map((item, i)=>(
                    <NavLink key={i} to={`${item.name}?subcode=${props.subCode}`}>
                        <li>
                            <div className="li-box">
                                <div className="li-box-icon">{<item.icon/>}</div>
                                <div className="li-box-name">{item.name}</div>
                                {item.count && <div className="li-box-count">{item.count}</div>}
                            </div>
                            <span></span>
                        </li>
                    </NavLink>
                ))}
            </ul>
        </div>
    )
}
